/**
 * ArtKornerGallery — Zoom panoramique v13 (style LUMAS)
 * v13 : le suivi de la souris pour le pan est deplace sur un listener
 * document-level (au lieu du survol du calque lui-meme), plus robuste
 * si d'autres elements se superposent partiellement au calque.
 */
(function () {
  'use strict';

  console.log('[AKG-ZOOM] script charge et execute (v13)');

  var ZOOM = 2.2;
  var hdCache = {};
  var activeState = null; // { img, overlay, parent }
  var docMoveHandler = null;

  function isInMainGallery(el) {
    return el && el.closest('.product-media-gallery') &&
      !el.closest('.product-media-gallery__thumbnails') &&
      !el.closest('.product-media-gallery__thumbnail');
  }

  function resolveGalleryImg(el) {
    if (!el || !isInMainGallery(el)) return null;
    if (el.tagName === 'IMG') return el;
    var img = el.querySelector ? el.querySelector('img') : null;
    if (img) return img;
    var wrap = el.closest('.product-media');
    if (wrap) return wrap.querySelector('img');
    return null;
  }

  function getHD(img) {
    if (!img.srcset) return img.src;
    var best = img.srcset.split(',').map(function (s) {
      var p = s.trim().split(/\s+/);
      return { url: p[0], w: parseInt(p[1]) || 0 };
    }).sort(function (a, b) { return b.w - a.w; });
    return best.length ? best[0].url : img.src;
  }

  function loadHD(src, cb) {
    if (hdCache[src]) { cb(true); return; }
    var t = new Image();
    t.onload = function () { hdCache[src] = true; cb(true); };
    t.onerror = function () {
      console.log('[AKG-ZOOM] echec de chargement image HD', src);
      cb(false);
    };
    t.src = src;
  }

  function positionOverlay(state) {
    var pRect = state.parent.getBoundingClientRect();
    var iRect = state.img.getBoundingClientRect();
    state.overlay.style.left = (iRect.left - pRect.left) + 'px';
    state.overlay.style.top = (iRect.top - pRect.top) + 'px';
    state.overlay.style.width = iRect.width + 'px';
    state.overlay.style.height = iRect.height + 'px';
    state.rect = iRect;
  }

  function pan(state, clientX, clientY) {
    var r = state.rect;
    if (!r || !r.width || !r.height) return;
    var relX = Math.min(1, Math.max(0, (clientX - r.left) / r.width));
    var relY = Math.min(1, Math.max(0, (clientY - r.top) / r.height));
    var bgW = r.width * ZOOM;
    var bgH = r.height * ZOOM;
    var bgX = -(relX * (bgW - r.width));
    var bgY = -(relY * (bgH - r.height));
    state.overlay.style.backgroundSize = bgW + 'px ' + bgH + 'px';
    state.overlay.style.backgroundPosition = bgX + 'px ' + bgY + 'px';
  }

  function deactivate() {
    if (!activeState) return;
    console.log('[AKG-ZOOM] desactivation du zoom');
    var state = activeState;
    activeState = null;
    if (state.img) {
      state.img.classList.remove('akg-zoom-source-hidden');
    }
    if (state.overlay && state.overlay.parentNode) {
      state.overlay.parentNode.removeChild(state.overlay);
    }
    if (state._onResize) {
      window.removeEventListener('resize', state._onResize);
      window.removeEventListener('scroll', state._onResize, true);
    }
    if (docMoveHandler) {
      document.removeEventListener('pointermove', docMoveHandler);
      document.removeEventListener('mousemove', docMoveHandler);
      docMoveHandler = null;
    }
  }

  function activate(img, clientX, clientY) {
    console.log('[AKG-ZOOM] activation du zoom sur', img.src);
    if (activeState) deactivate();

    var srcHD = getHD(img);
    loadHD(srcHD, function (ok) {
      if (!ok) return;

      var parent = img.parentElement;
      var cs = window.getComputedStyle(parent);
      if (cs.position === 'static') parent.style.position = 'relative';

      var overlay = document.createElement('div');
      overlay.className = 'akg-zoom-pan';
      overlay.style.backgroundImage = "url('" + srcHD + "')";
      parent.appendChild(overlay);

      img.classList.add('akg-zoom-source-hidden');

      var state = { img: img, overlay: overlay, parent: parent, rect: null };
      activeState = state;

      positionOverlay(state);
      pan(state, clientX, clientY);

      state._onResize = function () { positionOverlay(state); };
      window.addEventListener('resize', state._onResize);
      window.addEventListener('scroll', state._onResize, true);

      /* Suivi de la souris au niveau du document entier, tant que le zoom
         est actif — fonctionne meme si un autre element passe par-dessus
         le calque a certains endroits. */
      docMoveHandler = function (e) {
        if (!activeState) return;
        positionOverlay(activeState);
        pan(activeState, e.clientX, e.clientY);
      };
      document.addEventListener('pointermove', docMoveHandler);
      document.addEventListener('mousemove', docMoveHandler);

      overlay.addEventListener('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        deactivate();
      }, true);

      console.log('[AKG-ZOOM] calque de zoom cree et affiche');
    });
  }

  document.addEventListener('click', function (e) {
    if (activeState && activeState.overlay &&
        (e.target === activeState.overlay || activeState.overlay.contains(e.target))) {
      return;
    }

    var img = resolveGalleryImg(e.target);

    if (!img) {
      return;
    }

    console.log('[AKG-ZOOM] clic eligible, image resolue :', img.src);

    if (activeState) { deactivate(); return; }
    activate(img, e.clientX, e.clientY);
  }, true);

  document.addEventListener('contextmenu', function (e) {
    if (resolveGalleryImg(e.target) || (activeState && activeState.overlay && activeState.overlay.contains(e.target))) {
      e.preventDefault();
    }
  });

  document.addEventListener('dragstart', function (e) {
    if (resolveGalleryImg(e.target)) e.preventDefault();
  });

  /* Mise a jour "Dimensions finales" sous les boutons de taille */
  document.addEventListener('change', function (e) {
    if (!e.target || e.target.type !== 'radio') return;
    var fs = e.target.closest('.akg-option-buttons');
    if (!fs) return;
    var out = fs.querySelector('[data-akg-final-dims-value]');
    if (!out) return;
    var v = e.target.value.replace(/\s*cm/gi, '');
    out.textContent = v + ' cm';
  });

})();
